import { render, staticRenderFns } from "./SSTemplatesEditor.vue?vue&type=template&id=1356ab24"
import script from "./SSTemplatesEditor.vue?vue&type=script&lang=js"
export * from "./SSTemplatesEditor.vue?vue&type=script&lang=js"
import style0 from "./SSTemplatesEditor.vue?vue&type=style&index=0&id=1356ab24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports